import AddNewProperty from "./Child/AddNewProperty";
import REIToggablePanel from "../../components/ui/toggablePanel";
import AnalyserWatchList from "./Child/AnalyserWatchList";
import SavedAnalyser from "./SaveAnalyser";
import { REIButton, REIDialoge } from "../../components/ui";
import { ReactElement, useCallback, useEffect, useState } from "react";
import MyDefaultProfile from "../Search/Child/defaultProfile";
import { useLocation } from "react-router-dom";
import { Slider } from "primereact/slider";
import { clearFilterValue } from "../../store/slice/investarSearchSlice";
import { useDispatch } from "react-redux";
import style from "./AddProperty.module.scss";

const Index = () => {
  const location = useLocation();
  const [showDefaultProfile, setShowDefaultProfile] = useState<boolean>(false);
  const { propertyAnalyserId, propertyName } = location.state || {};
  const [forecastForYear, setForecastForYear] = useState<number>(1);
  const [reset, setReset] = useState<boolean>(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (reset) {
      dispatch(clearFilterValue());
      setReset(false);
    }
  }, [reset]);

  const hideDefaultProfile = useCallback(() => {
    setShowDefaultProfile(false);
  }, []);

  const headerTemplate = (options: any): ReactElement<any, any> => {
    const className = `${options.className} justify-content-space-between bg-slate-600 text-white`;

    return (
      <div className={className}>
        <div className="flex align-items-center gap-2">
          <span className="font-bold">Add a new property</span>
          <span className="mt-[2px] text-sm">
            (Either add a new property, or view properties you have saved or recently analysed.)
          </span>
        </div>
        <div>
          <REIButton
            id="pa-btn-defaultprofile"
            icon="pi pi-user-edit"
            label="My default profile"
            classNames="p-button-link text-white"
            onClick={() => setShowDefaultProfile(true)}
          />
          {options.togglerElement}
        </div>
      </div>
    );
  };

  const whatIhaveSavedHeaderTemplate = (options: any): ReactElement<any, any> => {
    const className = `${options.className} justify-content-space-between bg-slate-600 text-white`;

    return (
      <div className={className}>
        <div className="flex align-items-center gap-2">
          <span className="font-bold">What I've analysed</span>
        </div>
        <div className="flex items-center gap-4 p-4 bg-slate-600 text-white rounded-lg border">
          <label className="text-sm font-semibold text-white bg-slate-600 whitespace-nowrap">Forecast for:</label>
          <div className="flex items-center gap-3 flex-1">
            <Slider
              id="pa-sldr-forecastyear"
              data-testid="pa-sldr-forecastyear"
              value={forecastForYear}
              onChange={(e) => setForecastForYear(Array.isArray(e.value) ? e.value[0] : e.value)}
              className="flex-1 w-[150px]"
              max={10}
              min={1}
              step={1}
            />
            <span className="text-sm font-medium text-white bg-slate-600 px-3 py-1 rounded-md border shadow-sm">
              Year {forecastForYear}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <REIDialoge
        showHeader={true}
        header={`Edit Default Profile`}
        visible={showDefaultProfile}
        handleEditClick={hideDefaultProfile}
        position="top"
        style={{ width: "60vw" }}
        customClass="edit-default-profile"
        contentComponent={<MyDefaultProfile closeDialog={hideDefaultProfile} />}
      ></REIDialoge>
      <div className="flex flex-col lg:flex-row flex-wrap gap-2">
        <div className="flex flex-col lg:flex-row lg:w-full gap-2">
          <div id="pa-pnl-addnewproperty" data-testid="pa-pnl-addnewproperty" className="flex-0 lg:w-[60%] w-full">
            <REIToggablePanel
              header="Add a new property"
              istoggleable={false}
              defaultCollapse={false}
              customHeader={headerTemplate}
              customClassName={style?.panelWithBgColor}
              contentComponent={<AddNewProperty />}
            />
          </div>
          <div className="flex-0 lg:w-[40%] w-full">
            <REIToggablePanel
              id="pa-pnl-watchlist"
              header="My Investar Search watchlist"
              istoggleable={true}
              defaultCollapse={false}
              contentComponent={<AnalyserWatchList streetAddress={propertyName} />}
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row lg:w-full gap-2">
          <div id="pa-pnl-analysed" data-testid="pa-pnl-analysed" className="flex-0 w-full">
            <REIToggablePanel
              header="What I've analysed"
              istoggleable={false}
              defaultCollapse={false}
              customHeader={whatIhaveSavedHeaderTemplate}
              contentComponent={<SavedAnalyser forecastForYear={forecastForYear} />}
            />
          </div>
        </div>
      </div>
      <div className="content-center justify-center flex m-2 align-middle gap-2">
        <span className="text-center content-center italic">What do you think of Property Analyser? </span>
        <REIButton
          id="pa-btn-feedback"
          text
          label="Leave Feedback"
          onClick={() => {
            window.open("https://info.realestateinvestar.com.au/satisfaction-survey", "_blank");
          }}
          classNames="border-1 border-blue-200"
        ></REIButton>
      </div>
    </>
  );
};

export default Index;
